module.exports = __webpack_public_path__ + "img/cszr.cc68d65c.png";